import { useEffect } from 'react'
import * as Sentry from '@sentry/react'

import { useUser } from '@/hooks/use-user'

export function SentryIdentify() {
	const { user } = useUser()

	useEffect(() => {
		if (!user) {
			Sentry.setUser(null)
			return
		}

		Sentry.setUser({
			id: user.id,
			username: user.username,
			email: user.email,
			operatorId: user.portal_operator?.id,
			operatorName: user.portal_operator?.name,
			isAdmin: user.is_admin,
			isDriver: user.is_driver,
			role: user.role,
			tags: user.tags,
		})
	}, [user])

	return null
}
